/*
 *
 * App constants
 *
 */

export const SET_AUTH_TOKEN = 'src/App/SET_AUTH_TOKEN';
export const SET_USER       = 'src/App/SET_USER';
export const SIGN_OUT       = 'src/App/SIGN_OUT';
export const NOOP           = 'src/App/NOOP'



// WEBPACK FOOTER //
// ./src/containers/App/constants.js